export enum ContactRequestStatusEnum {
  UNKNOWN = "unknown",
  PENDING = "pending",
  CANCELLED = "cancelled",
  CLOSED = "closed",
}
